<template>
  <b-modal
    id="modal-loan-application"
    title="貸款申請書"
    size="lg"
    ok-title="修改"
    cancel-title="取消"
    @ok.prevent="handleSubmit"
    hide-footer
  >
  <validation-observer ref="refInformationFormObserver" tag="form">
    <b-overlay :show="loading" spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
    <b-form @submit.prevent="handleSubmit">
        <b-row v-if="formData.loan_information">
              <b-col cols="12" md="12">
                <h4>貸款申請書</h4>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`loan_amount_1`"
                  name="貸款本金"
                  rules="required|min_value:0"
                >
                  <b-form-group
                    label="貸款額"
                    :label-for="`loan_amount_1`"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      :id="`loan_amount_1`"
                      v-model="formData.amount"
                      type="number"
                      :state="getValidationState(validationContext)"
                      placeholder="輸入貸款本金"
                      :disabled="disable_field"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`period_1`"
                  name="供款期"
                  rules="required|min_value:0"
                >
                  <b-form-group
                    label="供款期"
                    :label-for="`period_1`"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      :id="`period_1`"
                      v-model="formData.period"
                      type="number"
                      :state="getValidationState(validationContext)"
                      placeholder="輸入供款期"
                      :disabled="disable_field"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`application_date`"
                  name="申請日期"
                  rules="required"
                >
                  <b-form-group
                    label="申請日期："
                    :label-for="`application_date`"
                    label-cols-md="4"
                    class="required"
                  >
                    <flat-pickr
                      v-model="
                        formData.loan_information.application_date
                      "
                      class="form-control"
                      :config="config3"
                      placeholder="輸入申請日期"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`loan_purpose`"
                  name="貸款用途"
                  rules="required"
                >
                  <b-form-group
                    label="貸款用途"
                    :label-for="`loan_purpose`"
                    label-cols-md="4"
                    class="required"
                  >
                    <v-select
                      v-model="formData.loan_information.loan_purpose"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="loanPurposeOptions"
                      :clearable="false"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`customer_source`"
                  name="客戶來源"
                  rules="required"
                >
                  <b-form-group
                    label="客戶來源"
                    :label-for="`customer_source`"
                    label-cols-md="4"
                    class="required"
                  >
                    <v-select
                      v-model="formData.loan_information.customer_source"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerSourceOptions"
                      :clearable="false"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <hr class="w-100 my-2" />
            <b-row v-if="formData.loan_information">
              <b-col cols="12" md="12">
                <h4>個人資料</h4>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="借款人姓名(中)"
                  rules="required"
                >
                  <b-form-group
                    label="借款人姓名(中)："
                    label-for="name_cn_1"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      id="name_cn_1"
                      type="text"
                      v-model="formData.name_cn"
                      :state="getValidationState(validationContext)"
                      placeholder="借款人姓名(中)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="借款人姓名(英)"
                  rules="required"
                >
                  <b-form-group
                    label="借款人姓名(英)："
                    label-for="name_en_1"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      id="name_en_1"
                      type="text"
                      v-model="formData.name_en"
                      :state="getValidationState(validationContext)"
                      placeholder="借款人姓名(英)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- id_number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="身份證號碼"
                  rules="required"
                >
                  <b-form-group
                    label="身份證號碼："
                    label-for="id_number_1"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      id="id_number_1"
                      v-model="formData.id_number"
                      @input="IsHKID(formData.id_number)"
                      :state="getValidationState(validationContext)"
                      placeholder="輸入身份證號碼"
                    />
                    <b-form-invalid-feedback :force-show="true">
                      {{ idError ? idError : validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="性別"
                  rules="required"
                >
                  <b-form-group
                    label="性別："
                    label-for="gender_id"
                    label-cols-md="4"
                    class="required"
                  >
                    <div class="form-col-select">
                      <v-select
                        v-model="formData.loan_information.gender_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="genderOptions"
                        :clearable="false"
                        label="gender"
                        :reduce="(option) => option.id"
                      />
                      <feather-icon size="18" icon="ChevronDownIcon" />
                    </div>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  :vid="`date_of_birth`"
                  name="出生日期"
                  rules="required|min:10"
                  :messages="{ min: '請輸入正確出生日期' }"
                >
                  <b-form-group
                    label="出生日期："
                    :label-for="`date_of_birth`"
                    label-cols-md="4"
                    class="required"
                  >
                    <cleave
                      id="date_of_birth"
                      v-model="formData.loan_information.date_of_birth"
                      class="form-control"
                      :raw="false"
                      :options="dateOptions"
                      placeholder="YYYY-MM-DD"
                    />
                    <!-- <flat-pickr
                      v-model="formData.loan_information.date_of_birth"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        dateFormat: 'Y-m-d',
                        maxDate: $store.state.app.maxDate,
                      }"
                      placeholder="輸入出生日期"
                    /> -->
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="年齡："
                  :label-for="`age`"
                  label-cols-md="4"
                  class="required"
                >
                  <b-form-input
                    id="age_1"
                    :value="
                      getAge(formData.loan_information.date_of_birth)
                    "
                    disabled
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="手提電話1："
                  label-for="mobile"
                  label-cols-md="4"
                  class=""
                >
                  <b-form-input
                    id="mobile"
                    type="text"
                    v-model="formData.loan_information.mobile"
                    placeholder="手提電話1"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="手提電話2："
                  label-for="tel"
                  label-cols-md="4"
                  class=""
                >
                  <b-form-input
                    id="tel"
                    type="text"
                    v-model="formData.loan_information.tel"
                    placeholder="手提電話2"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="通訊地址"
                  rules="required"
                >
                  <b-form-group
                    label="通訊地址："
                    label-for="address"
                    label-cols-md="2"
                    class="required"
                  >
                    <b-form-input
                      id="address"
                      type="text"
                      v-model="formData.address"
                      :state="getValidationState(validationContext)"
                      placeholder="通訊地址"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="租金/供樓金額"
                  rules="required"
                >
                  <b-form-group
                    label="租金/供樓金額："
                    label-for="rent_or_mortagage"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      id="rent_or_mortagage"
                      type="number"
                      v-model="
                        formData.loan_information.rent_or_mortagage
                      "
                      :state="getValidationState(validationContext)"
                      placeholder="租金/供樓金額"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="生活支出"
                  rules="required"
                >
                  <b-form-group
                    label="生活支出："
                    label-for="living_expenses"
                    label-cols-md="4"
                    class="required"
                  >
                    <b-form-input
                      id="living_expenses"
                      type="number"
                      v-model="formData.loan_information.living_expenses"
                      :state="getValidationState(validationContext)"
                      placeholder="生活支出"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <hr class="w-100 my-2" />
            <b-row v-if="formData.loan_information">
              <b-col cols="12" md="12">
                <h4>工作資料</h4>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  label="公司名稱："
                  label-for="company_name"
                  label-cols-md="2"
                  class=""
                >
                  <b-form-input
                    id="company_name"
                    type="text"
                    v-model="formData.loan_information.company_name"
                    placeholder="公司名稱"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group
                  label="公司地址："
                  label-for="company_address"
                  label-cols-md="2"
                  class=""
                >
                  <b-form-input
                    id="company_address"
                    type="text"
                    v-model="formData.loan_information.company_address"
                    placeholder="公司地址"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="職位："
                  label-for="position"
                  label-cols-md="4"
                  class=""
                >
                  <b-form-input
                    id="position"
                    type="text"
                    v-model="formData.loan_information.position"
                    placeholder="職位"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="工齡："
                  label-for="work_age"
                  label-cols-md="4"
                  class=""
                >
                  <b-input-group>
                    <b-form-input
                      id="work_age"
                      type="number"
                      v-model="formData.loan_information.work_age_year"
                      placeholder="年"
                    />
                    <b-input-group-append is-text> 年 </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                    <b-form-input
                      id="work_age"
                      type="number"
                      v-model="formData.loan_information.work_age_month"
                      placeholder="月"
                      v-limit-number:max="12"
                    />
                    <b-input-group-append is-text> 月 </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="支薪方式："
                  label-for="payment_method"
                  label-cols-md="4"
                  class=""
                >
                  <v-select
                    v-model="formData.loan_information.payment_method"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="salaryPaymentOptions"
                    :clearable="true"
                    placeholder="支薪方式"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="每月收入"
                  rules="required"
                >
                  <b-form-group
                    label="每月收入："
                    label-for="monthly_salary"
                    label-cols-md="4"
                    class="required|min_value:0"
                  >
                    <b-form-input
                      id="monthly_salary"
                      type="number"
                      v-model="formData.loan_information.monthly_salary"
                      placeholder="每月收入"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <hr class="w-100 my-2" />
            <b-row v-if="formData.loan_information">
              <b-col cols="12" md="12">
                <h4>兼職資料</h4>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  label="公司名稱："
                  label-for="pt_company_name"
                  label-cols-md="2"
                  class=""
                >
                  <b-form-input
                    id="pt_company_name"
                    type="text"
                    v-model="formData.loan_information.pt_company_name"
                    placeholder="公司名稱"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group
                  label="公司地址："
                  label-for="pt_company_address"
                  label-cols-md="2"
                  class=""
                >
                  <b-form-input
                    id="pt_company_address"
                    type="text"
                    v-model="
                      formData.loan_information.pt_company_address
                    "
                    placeholder="公司地址"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="職位："
                  label-for="pt_position"
                  label-cols-md="4"
                  class=""
                >
                  <b-form-input
                    id="pt_position"
                    type="text"
                    v-model="formData.loan_information.pt_position"
                    placeholder="職位"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="工齡："
                  label-for="pt_work_age"
                  label-cols-md="4"
                  class=""
                >
                  <b-input-group>
                    <b-form-input
                      id="pt_work_age"
                      type="number"
                      v-model="
                        formData.loan_information.pt_work_age_year
                      "
                      placeholder="年"
                    />
                    <b-input-group-append is-text> 年 </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                    <b-form-input
                      id="pt_work_age"
                      type="number"
                      v-model="
                        formData.loan_information.pt_work_age_month
                      "
                      placeholder="月"
                      v-limit-number:max="12"
                    />
                    <b-input-group-append is-text> 月 </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="支薪方式："
                  label-for="pt_payment_method"
                  label-cols-md="4"
                  class=""
                >
                  <v-select
                    v-model="formData.loan_information.pt_payment_method"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="salaryPaymentOptions"
                    :clearable="true"
                    placeholder="支薪方式"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="每月收入："
                  label-for="pt_monthly_salary"
                  label-cols-md="4"
                  class=""
                >
                  <b-form-input
                    id="pt_monthly_salary"
                    type="number"
                    v-model="formData.loan_information.pt_monthly_salary"
                    placeholder="每月收入"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr class="w-100 my-2" />
            <b-row v-if="formData.loan_information">
              <b-col cols="12" md="12">
                <h4>信貸狀況</h4>
              </b-col>

              <b-col cols="12" md="12" class="mb-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-sm-2 mobile-w100"
                  style="border-radius: 3px"
                  @click="addItem"
                >
                  <feather-icon size="16" class="mr-1" icon="PlusCircleIcon" />
                  新增信貸狀況
                </b-button>
              </b-col>
            </b-row>
            <div
              v-if="
                formData.loan_information &&
                formData.loan_information.histories
              "
            >
              <b-row
                v-for="(history, index) in formData.loan_information
                  .histories"
                :key="`history_${index}`"
                class="pb-2 mb-3"
              >
                <b-col cols="12">
                  <div class="d-flex border rounded">
                    <b-row class="flex-grow-1 p-2">
                      <!-- name -->
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-supplier_name${index}`"
                          name="信貸機構"
                          rules="required"
                        >
                          <b-form-group
                            label="信貸機構："
                            :label-for="`supplier_name${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <b-form-input
                              :id="`supplier_name${index}`"
                              v-model="history.supplier_name"
                              :state="getValidationState(validationContext)"
                              placeholder="輸入信貸機構"
                            />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`loan_type${index}`"
                          name="分期/循環"
                          rules="required"
                        >
                          <b-form-group
                            label="分期/循環"
                            :label-for="`loan_type${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <v-select
                              v-model="history.loan_type"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="paymentTypeOptions"
                              :clearable="false"
                            />
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <!-- amount -->
                      <b-col cols="12" md="6">
                        <b-form-group
                          label="貸款金額:"
                          :label-for="`amount_${index}`"
                          label-cols-md="3"
                        >
                          <b-form-input
                            :id="`amount_${index}`"
                            v-model="history.amount"
                            placeholder="輸入貸款金額"
                            type="number"
                            v-integer
                          />
                        </b-form-group>
                      </b-col>

                      <!-- payment_amount -->
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-supplier_name${index}`"
                          name="信貸機構"
                          rules="required"
                        >
                          <b-form-group
                            label="供款金額："
                            :label-for="`payment_amount_${index}`"
                            class="required"
                            label-cols-md="3"
                          >
                            <b-form-input
                              :id="`payment_amount_${index}`"
                              v-model="history.payment_amount"
                              :state="getValidationState(validationContext)"
                              placeholder="輸入供款金額"
                              type="number"
                              inputmode="numeric"
                              pattern="[0-9]*"
                              min="0"
                              v-integer
                            />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <!-- remain_period -->
                      <b-col cols="12" md="6">
                        <b-form-group
                          label="尚欠供款期："
                          :label-for="`remain_period_(${index})`"
                          label-cols-md="3"
                        >
                          <b-form-input
                            :id="`remain_period_(${index})`"
                            v-model="history.remain_period"
                            placeholder="輸入尚欠供款期"
                            v-if="history.loan_type != '循環'"
                            type="number"
                            v-integer
                          />

                          <b-form-input
                            :id="`remain_period_1_(${index})`"
                            disabled
                            placeholder="------"
                            v-if="history.loan_type == '循環'"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="6">
                        <b-form-group
                          label="總期數："
                          :label-for="`total_period_(${index})`"
                          label-cols-md="3"
                        >
                          <b-form-input
                            :id="`total_period_(${index})`"
                            v-model="history.total_period"
                            placeholder="輸入總期數"
                            type="number"
                            v-integer
                            v-if="history.loan_type != '循環'"
                          />
                          <b-form-input
                            :id="`total_period_(${index})`"
                            disabled
                            placeholder="------"
                            v-if="history.loan_type == '循環'"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div
                      class="d-flex flex-column justify-content-between border-left py-50 px-25"
                    >
                      <feather-icon
                        size="16"
                        icon="PlusIcon"
                        class="cursor-pointer text-success"
                        @click="addItem"
                      />
                      <feather-icon
                        size="16"
                        icon="XIcon"
                        class="cursor-pointer text-danger"
                        @click="removeItem(index, history)"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr class="w-100 my-2" />
            <b-row>
              <b-col cols="12" md="2" sm="6">
                <h5>收入</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{
                  (formData.loan_information &&
                    formData.loan_information.monthly_salary) ||
                  0
                }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>兼職</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{
                  (formData.loan_information &&
                    formData.loan_information.pt_monthly_salary) ||
                  0
                }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>收入總和</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{ total_salary }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>租金/供樓</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{
                  (formData.loan_information &&
                    formData.loan_information.rent_or_mortagage) ||
                  0
                }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>生活支出</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{
                  (formData.loan_information &&
                    formData.loan_information.living_expenses) ||
                  0
                }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>供款金額總和</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{ total_loan_amount }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>可用金額</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{ available_amount }}
              </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>支出總和</h5>
              </b-col>
              <b-col cols="12" md="2" sm="6">
                {{ total_expense }}
              </b-col>
              <b-col cols="12" md="12" sm="12"> </b-col>
              <b-col cols="12" md="2" sm="6">
                <h5>DSR%</h5>
              </b-col>
              <b-col cols="12" md="10" sm="6">
                <h5>{{ dsr }}</h5>
              </b-col>
              <hr class="w-100 my-2" />
            </b-row>

            <div class="d-flex mt-1 flex-wrap flex-sm-nowrap justify-content-end mb-1">
              <!-- 新增下載按鈕 -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                class="mr-sm-2 mobile-w100"
                @click="downloadApplicationForm(formData.id, formData.id_number)"
              >
                <feather-icon size="16" class="mr-1" icon="DownloadIcon" />
                下載貸款申請書
              </b-button>

              <!-- 原有的修改按鈕 -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                修改
              </b-button>

              <!-- 原有的取消按鈕 -->
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>

    </b-form>
</b-overlay>
</validation-observer>
  </b-modal>
</template>

<script>
import { BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BFormInvalidFeedback,BInputGroup,BOverlay,
    BInputGroupAppend, } from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import { validateID } from "@/libs/idValidator";
import flatPickr from "vue-flatpickr-component";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { maxDate } from "@/libs/helper";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import store from "@/store";
import { min_value } from "vee-validate/dist/rules";
extend("min_value", min_value);
import contractStoreModule from "@/views/contract/contractStoreModule";

export default {
    directives: {
    Ripple,
    integer: {
      bind: function (el, binding) {
        el.addEventListener("input", function (event) {
          const input = event.target;
          const value = Math.round(Number(input.value));
          if (value !== Number(input.value)) {
            input.value = value.toString();
            input.dispatchEvent(new Event("input"));
          }
        });
      },
    },
    "limit-number": {
      bind: function (el, binding) {
        const max = Number(binding.value) || Infinity;
        el.addEventListener("input", function (event) {
          const input = event.target;
          let value = Number(input.value);
          if (isNaN(value) || value < 0) {
            value = 0;
          } else if (value > max) {
            value = max;
          }
          if (input.value !== value.toString()) {
            input.value = value.toString();
            // Dispatch a change event instead of input
            input.dispatchEvent(new Event("change"));
          }
        });
      },
    },
  },
  components: {
    Cleave,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormInvalidFeedback
  },    
  name: 'ModalLoanApplication',
  props: {
    contractData: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
        salaryPaymentOptions: ["自動轉帳", "現金", "支票"],
        trigger: true,
        paymentTypeOptions: ["分期", "循環"],
        config: {
        allowInput: true,
        dateFormat: "Y-m-d",
        maxDate: maxDate,
      },
      config2: {
        altInput: true,
        altFormat: "Y-m-d",
        allowInput: true,
        dateFormat: "Y-m-d",
      },
      config3: {
        allowInput: true,
        dateFormat: "Y-m-d",
      },
      tem_data: {
        loan_date: null,
        period: null,
        is_monthly: null,
        first_pay_date: null,
      },
      dateOptions: {
        date: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
      },
      idOptions: {
        blocks: [1, 1, 1, 1, 1, 1, 1, 2],
        delimiter: " ",
        delimiters: [" ", "", "", "", "", "", "", ")"],
        numericOnly: true,
        uppercase: true,
      },
      idError: null,
      loan_is_monthly: [
        { id: 1, name: "月供" },
        { id: 0, name: "半月供" },
      ],
      tableColumns: [
        { key: "period", label: "期數" },
        { key: "pay_date", label: "供款日" },
        { key: "initial_principal", label: "期初本金" },
        { key: "principal", label: "每期本金" },
        { key: "interest", label: "利息" },
        { key: "payment_amount", label: "供款金額" },
        { key: "remaining_principal", label: "尚欠本金" },
      ],
      customerSourceOptions: [
        "Google ",
        "Yahoo",
        "Facebook",
        "Instagram",
        "報章",
        "朋友介紹",
        "短訊",
        "現有客戶",
        "其他",
      ],
      loanPurposeOptions: [
        '進修',
        '裝修',
        '醫療',
        '旅遊',
        '結婚',
        '日常開支',
        '其他'
      ]
    }
  },
  watch: {
    contractData: {
      immediate: true,
      handler(val) {
        if (val && val.loan_information) {
          this.formData = {
            ...val
          }
        }
      }
    }
  },
  methods: {
    // 統一證件驗證（香港 + 澳門），詳見 @/libs/idValidator
    IsHKID(str) {
      if (validateID(str)) {
        this.idError = "";
        return true;
      }
      this.idError = "證件號碼" + str + "不正確";
      return false;
    },
    hide() {
      this.$bvModal.hide('modal-loan-application')
    },
    downloadApplicationForm(id, id_number) {
      this.loading = true;
      this.$store
        .dispatch("app-contract/exportApplicationForm", { id })
        .then((response) => {
          this.loading = false;
          const fileDoc = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          });
          const fileURL = URL.createObjectURL(fileDoc);
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', `貸款申請書_${id_number}.docx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.loading = false;
          console.log({ error });
        });
    },
    removeItem(index, item) {
      if (item.id > 0) {
        this.$swal({
          title: "你確定嗎?",
          text: "您的行動是最終的，您將無法檢索這記錄。",
          showCancelButton: true,
          confirmButtonText: "刪除",
          cancelButtonText: "取消",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.$store
              .dispatch("app-contract/deleteHistory", { id: item.id })
              .then((response) => {
                this.$swal({
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
                this.$emit("refetch-data");
              })
              .catch((error) => {
                this.$swal({
                  text: JSON.stringify(error.response.data.message),
                  icon: "error",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              });
          }
        });
      } else {
        this.formData.loan_information.histories.splice(index, 1);
      }
    },
    addItem() {
      this.formData.loan_information.histories.push({
        id: 0,
        supplier_name: null,
        amount: null,
        payment_amount: null,
        remain_period: null,
        total_period: null,
      });
    },
    getAge(date_of_birth) {
      if (date_of_birth) {
        let today = new Date();
        let birthDate = new Date(date_of_birth);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          age = "不得借貸";
        }
        return age;
      }
    },
    addHistory() {
      this.formData.histories.push({
        supplier_name: '',
        loan_type: 'installment',
        amount: null,
        payment_amount: null,
        remain_period: null,
        total_period: null
      })
    },
    removeHistory(index) {
      this.formData.histories.splice(index, 1)
    },
    async handleSubmit() {
       
        const isValid = await this.$refs.refInformationFormObserver.validate()
    
    if (!isValid) {
      // 如果驗證失敗,顯示錯誤提示
      this.$swal({
        toast: true,
        title: '錯誤',
        text: '請檢查並填寫所有必填欄位',
        icon: 'warning',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false
      })
      return
    }

    this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "修改",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app-contract/addContract", this.formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
                buttonsStyling: false,
              });
              
             
            }).catch((error) => {
            
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => {
              this.loading = false;
              this.$emit("refetch-data");
            });
        }
      })
     




    },
    formatInput(value) {
      return Number(value) || 0;
    },
    calculateAge(birthDate) {
      if(!birthDate) return '';
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      
      if(monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    }
  },
  computed: {
    total_loan_amount() {
      //sum of this.formData.loan_information.histories amount field
      let total = 0;
      if (
        this.formData.loan_information &&
        this.formData.loan_information.histories
      ) {
        this.formData.loan_information.histories.forEach((item) => {
          total += Number(item.payment_amount);
        });
      }

      // don't delete below code, it's necessary (this force update the total_loan_amount)
      if (this.trigger || !this.trigger) {
      }

      total +=
        (!this.formData.is_monthly ? 2 : 1) *
        this.formatInput(this.formData.average_amount);
      return this.formatInput(total);
    },
    total_salary() {
      let monthly_salary =
        (this.formData.loan_information &&
          this.formData.loan_information.monthly_salary) ||
        0;
      let pt_monthly_salary =
        (this.formData.loan_information &&
          this.formData.loan_information.pt_monthly_salary) ||
        0;
      return this.formatInput(
        Number(monthly_salary) + Number(pt_monthly_salary)
      );
    },
    total_expense() {
      let living_expenses =
        (this.formData.loan_information &&
          this.formData.loan_information.living_expenses) ||
        0;
      let rent_or_mortagage =
        (this.formData.loan_information &&
          this.formData.loan_information.rent_or_mortagage) ||
        0;
      return this.formatInput(
        Number(living_expenses) +
          Number(rent_or_mortagage) +
          Number(this.total_loan_amount)
      );
    },
    available_amount() {
      return this.formatInput(this.total_salary - this.total_expense);
    },
    dsr() {
      //'dsr' = intval(($updateData['total_expense']) * 100 / intval($updateData['total_salary'])) . '%';
      return Math.round((this.total_expense * 100) / this.total_salary) + "%";
    },
    disable_field() {
      if (
        this.formData.id > 0 &&
        !this.formData.is_existing_loan
      ) {
        return true;
      } else {
        return false;
      }
    },
    scheduleData() {
      //check if any of the fields are null
      if (
        !this.formData ||
        this.formData.loan_date == null ||
        this.formData.amount == null ||
        this.formData.annual_interest_rate == null ||
        this.formData.period == null ||
        this.formData.interest_type_id == null
      ) {
        return null;
      }

      return {
        loan_date: this.formData.loan_date,
        amount: this.formData.amount,
        is_monthly: this.formData.is_monthly,
        annual_interest_rate: this.formData.annual_interest_rate,
        period: this.formData.period,
        interest_type_id: this.formData.interest_type_id,
        first_pay_date: this.formData.first_pay_date,
      };
    },
  },
  setup() {
    const CONTRACT_APP_STORE_MODULE_NAME = "app-contract";
    const formData = ref({})

    const resetContractData = () => {
        formData.value = {};
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetContractData);

      const genderOptions = ref([]);
      const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          gender: true
        })
        .then((response) => {
          genderOptions.value = response.data.genders;
        
        });
    };

    if (!store.hasModule(CONTRACT_APP_STORE_MODULE_NAME))
      store.registerModule(CONTRACT_APP_STORE_MODULE_NAME, contractStoreModule);

    onMounted(() => {
      refetchOption();
    });


    return {
      formData,
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      genderOptions
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

#modal-loan-application .modal-dialog {
  max-width: 1200px;
}

</style>

<style scoped>
.dsr-info-item {
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 8px;
}
</style> 

